import { useMutation, useQuery } from "@tanstack/react-query";
import {
  clearNotification,
  NotificationListing,
  readNotification,
} from "api/notification";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useNotificationListing = ({
  page = 1,
  limit = 10,
  ...options
} = {}) => {
  return useQuery({
    queryKey: ["notification_listing", page, limit],
    queryFn: () => NotificationListing({ page, limit }),
    keepPreviousData: true,
    ...options,
  });
};

export const useclearNotification = (options = {}) => {
  return useMutation({
    mutationFn: clearNotification,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const usereadNotification = (options = {}) => {
  return useMutation({
    mutationFn: readNotification,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", "Notification read successfully");
      options.onSuccess?.(data, variables, context);
    },
  });
};
